import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "mt-s3 caption" }, "Claimable", -1)
const _hoisted_2 = { class: "panel-data mt-s1 h3 flex align-items-center justify-content-center" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" BLUES ")

import { useVesting } from '@/composables/core/useVesting';
import AddTokenButton from '@/components/AddTokenButton.vue';
import { useWallet } from '@/composables/core/useWallet';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { claimableAmountFormatted } = useVesting();
const { isInjected } = useWallet();

return (_ctx: any,_cache: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (!_unref(claimableAmountFormatted))
        ? (_openBlock(), _createBlock(_component_Skeleton, {
            key: 0,
            class: "mr-2 w-7rem claim-skeleton"
          }))
        : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(claimableAmountFormatted)) + " ", 1)),
      _hoisted_4,
      (_unref(isInjected))
        ? (_openBlock(), _createBlock(AddTokenButton, {
            key: 2,
            onClick: _ctx.onAddToken,
            class: "ml-s3"
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})